import React from "react";
import { Link, Navigate } from "react-router-dom";
import { Breadcrumb, Card, Col, Row, Typography } from "antd";
import { IoGrid, IoBalloon } from "react-icons/io5";
import { RiGraduationCapFill } from "react-icons/ri";

import { POST_API, POST_CATCH, getToken } from "../services/hello-api";

import Pageload from "../components/Pageload";

class MenuClientes extends React.Component {

    state = { _loading: true, _navigate: false, _user: null, _menu: false }

    componentDidMount = () => {
        this.onView()
    }

    onView = () => {
        this.setState({_loading: true})
        if (getToken()) {
            POST_API('/credential/verify.php', { token: getToken() }).then(rs => rs.json()).then(res => {
                if (!res.return) {
                    this.setState({_navigate: true})
                } else {
                    this.setState({_user: res.user})
                }
            }).catch(() => POST_CATCH()).finally(() => {
                this.setState({_loading: false})
            })
        } else {
            this.setState({_navigate: true})
        }
    }

    render = ( ) => {

        const routes = this.props.bread

        if (this.state._navigate) return <Navigate to="/" />

        if (this.state._user === null || this.state._loading) return <Pageload />

        return (
            <Row>
                <Col xs={24} md={0}>
                    <Breadcrumb items={routes} className="bread-page" />
                </Col>
                <Col xs={0} md={24} className="page-header">
                    <Row className="table__row_table" gutter={[8,8]}>
                        <Col span={24}>
                            <Breadcrumb items={routes} />
                        </Col>
                    </Row>
                </Col>
                <Col span={24} className="page-content menu">
                    <Row gutter={[16,16]}>
                        <Col xs={12} md={4}>
                            <Link to="turmas">
                                <Card hoverable className="menu-card">
                                    <center><IoGrid size={20} className="menu-card-icon" /></center>
                                    <center><Typography className="menu-card-text">Turmas</Typography></center>
                                </Card>
                            </Link>
                        </Col>
                        <Col xs={12} md={4}>
                            <Link to="projetos">
                                <Card hoverable className="menu-card">
                                    <center><IoBalloon size={20} className="menu-card-icon" /></center>
                                    <center><Typography className="menu-card-text">Projetos</Typography></center>
                                </Card>
                            </Link>
                        </Col>
                        <Col xs={12} md={4}>
                            <Link to="formandos">
                                <Card hoverable className="menu-card">
                                    <center><RiGraduationCapFill size={20} className="menu-card-icon" /></center>
                                    <center><Typography className="menu-card-text">Formandos</Typography></center>
                                </Card>
                            </Link>
                        </Col>
                    </Row>
                </Col>
            </Row>
        )
    }

}

export default MenuClientes;